const gray = {
  'gray-05': '#080B11',
  'gray-10': '#16181D',
  'gray-12': '#1B1E24',
  'gray-15': '#21252C',
  'gray-20': '#2C303A',
  'gray-25': '#373C48',
  'gray-30': '#444A56',
  'gray-45': '#676F7E',
  'gray-55': '#818898',
  'gray-70': '#A8AFBD',
  'gray-90': '#E0E4EB',
  'gray-95': '#F0F2F5',
  'gray-100': '#FFFFFF',
};

const indigo = {
  'indigo-35': '#3C49DD',
  'indigo-43': '#4E55FA',
};

const mint = {
  'mint-25': '#134038',
  'mint-40': '#006655',
  'mint-85': '#5AF2D8',
  'mint-95': '#B8F9EE',
};

const red = {
  'red-45': '#CF1717',
  'red-60': '#EB4747',
  'red-85': '#FDB4B4',
};

const blue = {
  'blue-35': '#0069B2',
  'blue-45': '#0087E6',
  'blue-60': '#33AAFF',
  'blue-70': '#99D5FF',
  'blue-a-30': '#99D5FF4D',
};

const green = {
  'green-55': '#53C659',
};

const violet = {
  'violet-50': '#9271D9',
  'violet-60': '#AB84FF',
};

const transparent = {
  'white-a-5': '#FFFFFF0D',
  'white-a-10': '#FFFFFF1A',
  'white-a-15': '#FFFFFF26',
  'white-a-90': '#FFFFFFE6',
  'black-a-5': '#0000000D',
  'black-a-10': '#0000001A',
  'black-a-15': '#00000026',
};

const cursor = {
  'cursor-purple': '#8845F5',
  'cursor-red': '#EE3900',
  'cursor-yellow': '#FFCF24',
  'cursor-green': '#40A700',
  'cursor-fuchsia': '#E632B4',
  'cursor-blue': '#3F5DFB',

  'cursor-lilac': '#CEB1FC',
  'cursor-ice': '#66DFE7',
  'cursor-lime': '#BCE83D',
  'cursor-rose': '#FF9DBB',
  'cursor-peach': '#FFA800',
  'cursor-lavender': '#B7CFFE',

  'cursor-brown': '#80483B',
  'cursor-teal': '#15728F',
  'cursor-olive': '#8B8604',
  'cursor-sand': '#E9C570',
  'cursor-steel': '#C3CCD5',
  'cursor-grey': '#666666',
} as const;

export const colors = {
  ...gray,
  ...green,
  ...indigo,
  ...mint,
  ...red,
  ...blue,
  ...violet,
  ...transparent,
  ...cursor,
} as const;
